export enum AmplitudeEvents {
  PATIENT_CALL_HISTORY = 'patient_call_history',
  PATIENT_FAV_DOCTOR = 'patient_fav_doctor',
  PATIENT_REMOVE_FAV_DOCTOR = 'patient_remove_fav_doctor',
  PATIENT_SETTINGS = 'patient_settings',
  PATIENT_LOGOUT = 'patient_logout',
  LOGIN_TOKEN = 'login_token',
  LOGIN_AUTH0 = 'login_Auth0',
  PATIENT_SELECT_SPECIALTY = 'paciente_selecciono_especialidad',
  PATIENT_SELECT_REASON = 'paciente_selecciono_motivo',
  PATIENT_SELECT_RECORDS = 'paciente_selecciono_antecedentes',
  PATIENT_SELECT_START_FACIAL_SCAN = 'paciente_selecciono_iniciar_escaneo_facial',
  PATIENT_OMIT_START_FACIAL_SCAN = 'paciente_omitio_iniciar_escaneo_facial',
  START_FACIAL_SCAN_ERROR = 'error_iniciar_escaneo_facial',
  PATIENT_SELECT_DOCTOR = 'paciente_selecciono_medico',
  PATIENT_DOCTOR_DETAIL_IN_APPOINTMENT = 'patient_doctor_detail_in_appointment',
  PATIENT_MEDIA_PERMISSIONS_GRANTED = 'paciente_otorgo_permisos_camara_microfono',
  PATIENT_MEDIA_PERMISSIONS_NOT_GRANTED = 'paciente_no_otorgo_permisos_camara_microfono',
  PATIENT_CALLING = 'paciente_llamando',
  CALLING_BY_DOCTOR = 'llamando_por_doctor',
  CALLING_BY_SPECIALTY = 'llamando_por_especialidad',
  CALL_CREATED_BY_SPECIALTY = 'llamada_creada_por_especialidad',
  DOCTOR_NOT_AVAILABLE = 'doctor_no_disponible',
  REDIRECTING_TO_VIDEO_CALL = 'redireccionando_a_videollamada',
  CALL_DATA_SIGNAL_RECEIVED = 'signal_con_datos_de_la_llamada_recibida',
  CALL_BY_SPECIALTY_ERROR = 'error_llamada_por_especialidad',
  CALL_ERROR = 'error_llamada',
  CALL_DISCONNECTED_BY_USER = 'llamada_desconectada_por_usuario',
  CALL_DISCONNECTED_BY_TIMEOUT = 'llamada_desconectada_por_timeout',
  CALL_DISCONNECTED_AUTO = 'paciente_desconectado_automaticamente_de_llamada',
  CALL_CONNECTION_FAILED = 'llamada_comunicacion_fallida',
  END_CALL_ERROR = 'error_paciente_finalizando_llamada',
  PARSING_SIGNAL_EVENT_ERROR = 'error_obteniendo_información_evento_signal',
  CANNOT_SUBSCRIBE_DUE_TO_PATIENT_IN_WAITING_PAGE = 'subscribe_omitido_paciente_en_pantalla_de_espera',
  CANNOT_SUBSCRIBE_DUE_TO_SESSION_NOT_INITIALIZED = 'subscribe_omitido_sesion_no_inicializada',
  PUBLISHER_NOT_INITIALIZED_RETRYING = 'publisher_no_inicializado_reintentando',
  ON_CALL_OPENTOK_ERROR = 'error_opentok_durante_llamada',
  ON_CALL_OPENTOK_EXCEPTION = 'excepcion_opentok_durante_llamada',
  ON_CALL_RELOAD_PAGE = 'paciente_refresco_pantalla_durante_llamada',
  ON_CALL_CONNECTION_CREATED_EVENT = 'evento_conexion_creada_recibido',
  ON_CALL_CONNECTION_DESTROYED_EVENT = 'evento_conexion_destruida_recibido',
  ON_CALL_STREAM_CREATED_EVENT = 'evento_stream_creado_recibido',
  ON_CALL_STREAM_DESTROYED_EVENT = 'evento_stream_destruido_recibido',
  ON_CALL_SESSION_DISCONNECTED_EVENT = 'evento_sesion_desconectada_recibido',
  ON_CALL_SESSION_RECONNECTING_EVENT = 'evento_reconectando_sesion_recibido',
  ON_CALL_SESSION_RECONNECTED_EVENT = 'evento_sesion_reconectada_recibido',
  ON_CALL_PATIENT_INITIALIZING_SESSION = 'paciente_inicializando_sesion',
  ON_CALL_PATIENT_CONNECTED_TO_SESSION = 'paciente_se_conecta_a_sesion',
  ON_CALL_PATIENT_CONNECTING_TO_SESSION_ERROR = 'error_conectando_paciente_a_sesion',
  ON_CALL_PATIENT_PUBLISHED = 'paciente_publica_stream',
  ON_CALL_PATIENT_PUBLISH_AUDIO = 'paciente_publica_audio',
  ON_CALL_PATIENT_PUBLISH_AUDIO_AND_VIDEO = 'paciente_publica_audio_y_video',
  ON_CALL_PATIENT_SUBCRIBED_TO_STREAM = 'paciente_se_suscribe_a_stream',
  ON_CALL_TRY_RECONNECT_SESSION = 'intento_de_reconexion_de_sesion',
  ON_CALL_SESSION_RECONNECTED = 'sesion_reconectada',
  ON_CALL_SESSION_RECONNECTING_ERROR = 'error_reconectando_sesion',
  PATIENT_QUALIFYING_CALL = 'paciente_calificando_llamada',
  PATIENT_CALL_QUALIFY = 'paciente_califico_llamada',
  FAMILY_GROUP_CALLER = 'family_group_caller',
  USER_NOT_ACTIVE = 'user_not_active',
  PATIENT_TOGGLE_CAMERA = 'paciente_alterno_camara',
  PATIENT_TOGGLE_MICROPHONE = 'paciente_alterno_microfono',
  PATIENT_SWITCH_CAMERA = 'paciente_cambio_camara',
  PATIENT_CANCELLED_CALL = 'paciente_cancela_llamada',
  CALL_STATUS_WAITING_DOCTOR_FAILED = 'call_status_waiting_doctor_failed',
  PATIENT_UPLOAD_MEDICAL_EXAM = 'paciente_carga_estudio',
  PATIENT_DELETES_MEDICAL_EXAM = 'paciente_elimina_estudio',
  PATIENT_BOOKED_APPOINTMENT = 'paciente_reserva_turno',
  PATIENT_CANCELED_APPOINTMENT = 'paciente_cancela_turno',
  PATIENT_ASK_FOR_HC = 'paciente_solicita_HC',
  PATIENT_WEB_SOCKET_CONNECTED = 'paciente_web_socket_conectado',
  PATIENT_WEB_SOCKET_DISCONNECTED = 'paciente_web_socket_desconectado',
  TRANSLATOR_WEB_SOCKET_CONNECTED = 'translator_web_socket_conectado',
  TRANSLATOR_WEB_SOCKET_DISCONNECTED = 'translator_web_socket_desconectado',
  TRANSLATOR_WEB_SOCKET_DUPLICATING_CONNECTION_ERROR = 'error_translator_web_socket_duplicando_conexion',
  PATIENT_UPLOAD_FILE = 'paciente_carga_archivo',
  PATIENT_UPLOAD_FILE_ERROR = 'error_paciente_carga_archivo',
  DEVICE_NOT_SUPPORT_CODEC = 'dispositivo_no_soporta_codec',
  PATIENT_GRANTED_GEOLOCATION_PERMISSION = 'paciente_acepto_permiso_geolocalizacion',
  PATIENT_DENIED_GEOLOCATION_PERMISSION = 'paciente_denego_permiso_geolocalizacion',
  PATIENT_GPS_DISABLED = 'gps_desactivado',
  PATIENT_SEND_DATA_REQUEST = 'paciente_envia_solicitud_datos',
  PATIENT_DISABLED_WEB_SERVICE = 'muestra_popup_paciente_no_habilitado_web_service',
  PATIENT_REDIRECTED_TO_DATA_VALIDATION = 'paciente_redirigido_a_validación_de_datos',
  PATIENT_CHAT_SEND_MESSAGE = 'paciente_envia_mensaje_chat',
  PATIENT_CHAT_RECEIVE_MESSAGE = 'paciente_recibe_mensaje_chat',
  PATIENT_ACTIVATES_HEARING_DIFFICULTIES = 'paciente_activa_dificultades_auditivas',
  PATIENT_DEACTIVATES_HEARING_DIFFICULTIES = 'paciente_desactiva_dificultades_auditivas',
}
